/**
 * @documental
 * @export Action
 * @name
 * DataList.Actions.Action
 */

import { ReactNode } from "react";
import { Button, ButtonAppearance } from "../Button";
import { IconName } from "../Icon";
import { useDataListRow } from "./useDataListRow";
import { DataId } from "../DataId";
import { BaseProps } from "../../BaseProps";

/**
 * The `Action` component properties.
 */
export interface DataListActionProps extends BaseProps {
   /**
   * The action icon.
   */
  readonly icon: IconName;

   /**
   * The action tooltip.
   */
  readonly tooltip?: string;

   /**
   * Called when the action is clicked.
   */
  readonly onClick: (id: DataId) => void;

   /**
   * Function which called indicates whether the action is visible.
   */
  readonly visible?: (id: DataId) => boolean;

   /**
   * Function which called indicates whether the action is disabled.
   */
  readonly disabled?: (id: DataId) => boolean;

   /**
   * The action children.
   */
  readonly children?: ReactNode;

   /**
   * The action button appearance.
   */
  readonly buttonAppearance?: ButtonAppearance;
}

export function ListAction(props: DataListActionProps) {
  const { row, id } = useDataListRow();
  if (!row) return null;
  const { icon, tooltip, children, buttonAppearance, onClick, disabled } = props;
  const isDisabled = disabled ? disabled(id) : false;
  return (
    <Button
      icon={icon}
      tooltip={tooltip}
      onClick={() => onClick(id)}
      appearance={buttonAppearance}
      disabled={isDisabled}
    >
      {children}
    </Button>
  );
}
